import { isImpersonatedUser } from '@helios/frontend-auth';
import { requestV2 } from '../index';
import { WeeklyEnergyBudget, WeeklyEnergyBudgetsParams, WeeklyEnergyBudgetsPostRequest } from './types';

export const WEEKLY_ENERGY_BUDGETS_ENDPOINT = '/properties';

export const getCurrentWeekEnergyBudget = async (propertyId: string): Promise<WeeklyEnergyBudget> => {
  const today = new Date().toISOString();
  const result = await requestV2({
    url: `${WEEKLY_ENERGY_BUDGETS_ENDPOINT}/${propertyId}/weekly-energy-budgets/current-week`,
    params: { today },
  });
  return result.data;
};

export const getWeeklyEnergyBudgets = async (
  propertyId: string,
  params?: WeeklyEnergyBudgetsParams,
): Promise<WeeklyEnergyBudget> => {
  const result = await requestV2({
    url: `${WEEKLY_ENERGY_BUDGETS_ENDPOINT}/${propertyId}/weekly-energy-budgets`,
    params,
  });
  return result.data;
};

export const postWeeklyEnergyBudgetViewed = async ({
  propertyId,
  budgetId,
}: WeeklyEnergyBudgetsPostRequest): Promise<void> => {
  if (isImpersonatedUser()) {
    return;
  }
  await requestV2({
    method: 'POST',
    url: `${WEEKLY_ENERGY_BUDGETS_ENDPOINT}/${propertyId}/weekly-energy-budgets/${budgetId}/view`,
    data: {
      viewed: true,
    },
  });
};
